<template>
  <div>
    <Smainl></Smainl>
    <div class="page_content_share">
      <div class="case_collect_card_list">
        <div class="case_collect_card_list_item"  v-for="(v,key) in tableData" :key="key" v-if="tableData.length>0">
          <div class="case_collect_card_list_item_title">
            <span>{{v.brand_name?v.brand_name:"--"}} | {{v.name?v.name:"--"}}</span>
            <div>
              <el-button type="text" @click="detail(v)">详情</el-button>
            </div>
          </div>
          <p class="case_collect_card_list_item_desc">
            {{v.service_content?v.service_content:"--"}}
          </p>
          <div :class="{ [`case_collect_card_list_item_imgs_${v.count_files}`]: true }">
            <template v-for="(v_a, k_a) in v.annexAll">
              <video v-if="v_a.suffix === 'mp4'" :key="k_a" :src="v_a.url"></video>
              <img v-else :key="k_a" :src="v_a.url" />
            </template>
          </div>
        </div>
      </div>
      <div class="pagation" v-if="tableData.length>0">
        <template>
          <el-pagination
            style="margin-top: 10px; text-align: right;"
            layout="sizes,prev, pager, next,total,jumper"
            :total="total"
            :page-size="pageSize"
            :page-sizes="[5, 10, 20]"
            popper-class="pagepop"
            @current-change="handlePageChange"
            :current-page.sync="currentPage"
          >
          </el-pagination>
        </template>
      </div>
      <div v-else class="case_card_list_no_data">
        <img  :src="require('@/assets/img/demand/img_empty.png')"/>
        <p>暂无案例</p>
      </div>
    </div>
  </div>
</template>
<script >
/* eslint-disable */
import Smainl from '@/components/Smainl.vue'
import Cookies from "js-cookie";
import * as commfun from "@/common/common.js"

// import index_mixins_page from "@/common/index_mixins_page.js"
export default {
  name: 'Index',
  components: {
    Smainl,
  },
  data: function () {
    return {
      tableData: [],
      highsearch_submit:{},
      is_share:0,
      loading_txt:'数据加载中',
      loading:false,
      total:0,
      pageSize: 5,             // 每页数量
      currentPage: 1,           // 当前页面
      totalPages: 0,             // 总页数
    };
  },
  mounted() {
    this.initList()
  },
  methods: {
    //详情界面跳转
    detail(row){
      window.open("/sharedetail?id="+row.encrypt_case_id)
    },
    initList: function (){
      var selfthis = this
      var url = "/adapi/share/ajaxList"
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var id = urlParams.get('id');
      var data={
        id:id,
        page_num:this.pageSize,
        page:this.currentPage,
        totalPages:this.totalPages,
      }
      selfthis.loading=true
      commfun.ajaxPost(selfthis,url,data,function (selfthis,data){
        selfthis.loading=false
        selfthis.tableData = data.list
        selfthis.total  = data.total
      },function (selfthis,dataError){
        commfun.showMessage(selfthis,'warning',"错误："+dataError.msg)
      })
    },
    handlePageChange(currentPage) {
      // 处理页码变化回调，更新 currentPage 并重新获取数据
      this.currentPage = currentPage;
      this.initList();
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/ShareList.vue